var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /builds/hatchet/creativemazes/wp-content/themes/creative-mazes-theme/node_modules/lodash/_Symbol.js
// module id = 7
// module chunks = 0